import React, { useState, useEffect } from 'react'

interface BubbleTestProps {
  content: string
  onTypingComplete: any
  typing: boolean | undefined
  speed?: number
  className?: string
  style?: React.CSSProperties
}

const BubbleTest: React.FC<BubbleTestProps> = props => {
  const {
    content,
    onTypingComplete,
    typing,
    speed = 20,
    style = undefined,
    className = undefined
  } = props
  const [displayedText, setDisplayedText] = useState(typing ? '' : content)

  useEffect(() => {
    if (typing) {
      let index = 0
      const interval = setInterval(() => {
        setDisplayedText(prev => prev + content[index])
        index++
        if (index === content.length) {
          clearInterval(interval)
          onTypingComplete?.()
        }
      }, speed)
      return () => clearInterval(interval)
    } else {
      setDisplayedText(content)
    }
  }, [content, typing])

  return (
    <span style={style} className={className}>
      {displayedText}
    </span>
  )
}

export default React.memo(BubbleTest)
